import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios';
import { Layout } from '../Layout';
import '../../Asset/vendors/base/vendors.bundle.css';
import '../../Asset/demo/default/base/style.bundle.css';
import '../../Asset/custom.css';
import { Card, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import Spinner from '../Spinner';
import { config } from '../../Constants';
import global from '../global';
export class ESignCancel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: 100,
            RemitterCode: '',
            url: '',
        };

    }

    componentDidMount() {
        axios.get(global.UserManagement.GetSessionDetailsAPI)
            .then(response => {
                if (response.data.Status) {
                    this.setState({
                        RemitterCode: response.data.RemitterCode,
                        url: config.url.Web_URL + '/' + response.data.RemitterCode
                    });
                } else {
                    window.location.href = config.url.Web_URL + `/Error/404`;
                    return;
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        if (this.state.loading) return <Spinner />;

        let content = Layout.RenderNavMenu();

        return (

            <div>
                {content}
                <div className="m-grid__item m-grid__item--fluid m-wrapper">
                    <div className="Nexdigm">
                        <ol className="breadcrumb btn-Nexdigm">
                            <li><a href={this.state.url + "/Dashboard?UT=" + window.btoa(this.state.RemitterCode.toUpperCase() == "NEXDIGM" ? "A" : "U")} className="text-white"><FontAwesomeIcon icon="home" /> Home</a></li>
                            <li><a href={this.state.url + "/Form15GH"} className="text-white">Form 15 G/H</a></li>
                            <li><a className="text-white">Cancel</a></li>
                        </ol>
                    </div>
                    <div className="content-page">
                        <div className="card">
                            <div className="card-body">
                                <Row>
                                    <Col md={12}>
                                        <h4 className="text-center text-danger">Request Cancelled by User</h4>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

